import type { Accessor } from "solid-js";
import { createEffect, createSignal } from "solid-js";

export const createPreviousMemo = <T>(get: Accessor<T>): Accessor<T | undefined> => {
  let currValue: T | undefined = undefined;
  const [prev, setPrev] = createSignal<T | undefined>();
  createEffect(() => {
    const nextValue = currValue;
    setPrev(() => nextValue);
    currValue = get();
  });
  return prev;
};
